import { EmailPreferencesSchema, EmailPreferencesTransformer } from '../api/types';
import { UserSchema } from '../types';

export function userTransformer(user?: UserSchema): any {
  if (user) {
    const { language, ...props } = user;
    return { ...props, language: language ?? 'en-US' };
  }
}

export function emailPreferencesTransformer(data: EmailPreferencesSchema): EmailPreferencesTransformer {
  return {
    id: data.id,
    user: data.user,
    recommendationsByInterests: data.recommendations_by_interests,
    recommendationsByActivity: data.recommendations_by_activity,
    newsletterMkt: data.newsletter_mkt,
    dateCreated: data.date_created,
    dateUpdated: data.date_updated,
  };
}
